import { Errors } from "../enums/errors.enums";
import { ErrorCodeDetails } from "../types/error.types";
import NotFoundIcon from "../../theme/assets/404-Icon.svg";
import ServerErrorIcon from "../../theme/assets/500-Icon.svg";

type ErrorConstantsType = {
  [E in Errors]: Omit<ErrorCodeDetails, "code"> & { code: E };
};

export const ErrorConstants: ErrorConstantsType = {
  [Errors.UNKNOWN_ERROR]: {
    code: Errors.UNKNOWN_ERROR,
    title: "Unknown Error",
  },
  [Errors.NOT_FOUND]: {
    code: Errors.NOT_FOUND,
    title: "404 ERROR",
    detailedMessage:
      "This page does not exist. We have noted this error and are looking into it.",
    icon: NotFoundIcon,
  },
  [Errors.SERVER_ERROR]: {
    code: Errors.SERVER_ERROR,
    title: "500 ERROR",
    detailedMessage:
      "The site cannot display this page. We've noted this error and are looking into it.",
    icon: ServerErrorIcon,
  },
  [Errors.FORBIDDEN]: {
    code: Errors.FORBIDDEN,
    title: "Access Denied",
  },
};

export default ErrorConstants;
